import { 
    ACCOUNT_INFORMATION_REQUEST,
    ACCOUNT_INFORMATION_SUCCESS,
    ACCOUNT_INFORMATION_FAILED
 } from '../../../actionTypes'

 const initialState = {
     data:[],
     isLoading: false
 }

 const accountInformationReducer = (state = initialState, action) =>{
     switch (action.type) {
          // edit user
        case ACCOUNT_INFORMATION_REQUEST:
            return {
              ...state,
              isLoading: true,
            };
          case ACCOUNT_INFORMATION_SUCCESS:
            return {
              ...state,
              isLoading: false,
              data: action.payload,
            };
          case ACCOUNT_INFORMATION_FAILED:
            return {
              ...state,
              isLoading: false,
              error: action.error,
            };
    
          default:
            return state;
     }
 };

 export default accountInformationReducer;